export class TokenModel {
  access_token = ''
  token_type: 'bearer' = 'bearer'
  expires_in = 0
  expires_at: Date | string = ''
  refresh_token = ''
}

export enum RoleUserModel {
  SuperUser = 'SuperUser',
  User = 'User',
  Reseller = 'Reseller',
}

export class AccessTokenModel {
  Access = ''
  ApiConsumerId = ''
  RoleId: RoleUserModel = RoleUserModel.User
  UserId = ''
  exp = 0
  iat = 0
  nbf = 0
  ResellerId = ''
}
